var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("transition", { attrs: { name: "slide-up" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isVisible,
                expression: "isVisible",
              },
            ],
            staticClass: "customer-service-panel",
          },
          [
            _c("div", { staticClass: "customer-service-header" }, [
              _c("span", { staticClass: "customer-service-title" }, [
                _vm._v("在线客服"),
              ]),
              _c("i", {
                staticClass: "el-icon-close close-btn",
                on: { click: _vm.togglePanel },
              }),
            ]),
            _c("div", { staticClass: "customer-service-content" }, [
              _c("iframe", {
                ref: "serviceIframe",
                staticClass: "customer-service-iframe",
                attrs: {
                  src: _vm.customerServiceUrl,
                  frameborder: "0",
                  allow: "microphone; camera",
                },
              }),
            ]),
          ]
        ),
      ]),
      _c(
        "div",
        {
          staticClass: "customer-service-icon",
          on: { click: _vm.togglePanel },
        },
        [
          _c("i", {
            class: _vm.isVisible ? "el-icon-close" : "el-icon-chat-dot-round",
          }),
          _c("span", { staticClass: "customer-service-text" }, [
            _vm._v(_vm._s(_vm.isVisible ? "关闭" : "客服")),
          ]),
          _vm.unreadCount > 0
            ? _c("span", { staticClass: "unread-badge" }, [
                _vm._v(_vm._s(_vm.unreadCount > 99 ? "99+" : _vm.unreadCount)),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }